import { useSelector } from "react-redux";
import { developerTools, apps } from "../../portfolioData";
import "./index.css";

const TechStack = () => {
  const theme = useSelector((state) => state.theme);
  const textColor = theme === "LIGHT" ? "tech-stack-light" : "tech-stack-dark";
  const techStackDetailsTitle =
    theme === "LIGHT"
      ? "tech-stack-details-title-light"
      : "tech-stack-details-title-dark";

  const techCardClass =
    theme === "LIGHT" ? "tech-card-light" : "tech-card-dark";

  const techCardTagClass =
    theme === "LIGHT" ? "tech-card-tag-light" : "tech-card-tag-dark";

  const techCard = (tool) => {
    let { title, tag, iconUrl } = tool;
    if (iconUrl === "") {
      iconUrl =
        theme === "LIGHT"
          ? "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696408857/Portfolio%20App/icons8-nodejs-144_iud7xx.png"
          : "https://res.cloudinary.com/ddaimmqrr/image/upload/v1696417758/Portfolio%20App/logo_1_wvpdkr.svg";
    }

    return (
      <div className={`tech-card ${techCardClass}`}>
        <div className="tech-card-icon-container">
          <img className="tech-card-icon" src={iconUrl} alt="title" />
        </div>
        <footer className="tech-card-footer">
          <h3 className="tech-card-title">{title}</h3>
          <p className={`tech-card-tag ${techCardTagClass}`}>{tag}</p>
        </footer>
      </div>
    );
  };

  return (
    <div className={`tech-stack ${textColor}`}>
      <h1 className="tech-stack-title">Tech Stack</h1>
      <p className="tech-stack-caption">
        The dev tools and apps I use and play..
      </p>
      <hr
        style={{
          background:
            theme === "LIGHT"
              ? "rgba(0, 0, 0, 0.10)"
              : "rgba(255, 255, 255, 0.10)",
          width: "100vw",
          position: "relative",
          left: "calc((100% - 100vw) / 2)",
        }}
      />
      <section className="tech-stack-details-section">
        <h2 className={`tech-stack-details-title ${techStackDetailsTitle}`}>
          Dev & Design
        </h2>
        <ul className="tech-cards-container row mb-5">
          {developerTools.map((tool) => (
            <li key={tool.id} className="col-12 col-md-6 col-lg-4">
              {techCard(tool)}
            </li>
          ))}
        </ul>
        <h2 className={`tech-stack-details-title ${techStackDetailsTitle}`}>
          Apps
        </h2>
        <ul className="tech-cards-container row mb-5">
          {apps.map((tool) => (
            <li key={tool.id} className="col-12 col-md-6 col-lg-4">
              {techCard(tool)}
            </li>
          ))}
        </ul>
      </section>
    </div>
  );
};

export default TechStack;
